import React from 'react';
import './CustomRadioButton.scss';

const CustomRadioButton = ({ label, value, checked, onChange }) => {
    return (
        <label className="custom-radio">
            <input
                type="radio"
                value={value}
                checked={checked}
                onChange={onChange}
            />
            <span className="radio-mark"></span>
            {label && <span className="radio-label">{label}</span>}
        </label>
    );
};

export default CustomRadioButton;
